import styled from '@emotion/styled';
import {
  Button,
  Input,
  Modal,
  notification,
  Select,
  Space,
  Tooltip,
} from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { generate } from 'short-uuid';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import {
  TitreBidAskType,
  TitreEntity,
} from '../../../../entities/titre.entity';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { formatNum } from '../../../../shared/constants';
import type { OrderPrefill } from '../../pages/dashboard';
import { createFavoris, createOperation } from '../../network';
import { ConfirmationOrder } from './components/ConfirmOrder';
import { FractionOrder } from './components/FractionOrder';

const Container = styled.div`
  font-family: Poppins-R;
  height: 100%;
  min-width: 0;
  color: var(--mt-text);

  table,
  th,
  td {
    border-bottom: 1px solid rgba(148, 163, 184, 0.2);
    border-top: 0;
    padding-left: 8px;
  }

  td {
    margin: 2px;
    height: 22px;
  }

  td:nth-of-type(odd) {
    color: var(--mt-muted);
    font-size: 12px;
  }

  td div {
    padding: 2px 5px;
  }

  .anticon {
    color: var(--mt-text);
  }

  .colortrans td {
    // background-color: rgba(255, 255, 255, 0.5);
  }

  td
    .ant-select-single.ant-select-sm:not(.ant-select-customize-input)
    .ant-select-selector {
    padding: 0 7px;
    background-color: transparent;
    color: var(--mt-text);
    border: none;
  }

  td .coloriage {
    background-color: ${YELLOW};
    color: #1f2933;
    width: 100%;
    padding-left: 2px;
    border-radius: 3px;
  }

  td .coloriage2 {
    padding-left: 2px;
    background-color: var(--mt-surface-strong);
    color: var(--mt-text);
    width: 100%;
    border-radius: 3px;
  }

  td .coloriage1 {
    background-color: ${ORANGE};
    color: #fff;
    width: 100%;
    border-radius: 3px;
  }

  .qteInput {
    width: 100px;
    height: 22px;
    background-color: transparent;
    color: var(--mt-text);
    border: none;
  }

  > .top {
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.16), transparent 36%),
      ${PRIMARY};
    padding: 8px 12px;
    font-family: Poppins-R;
    text-transform: uppercase;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .ticket-title {
    align-items: center;
    display: flex;
    gap: 8px;
  }

  .ticket-kicker {
    color: ${YELLOW};
    font-family: Poppins-B;
    letter-spacing: 0.06em;
  }

  .order-side {
    border-radius: 999px;
    color: #07141c;
    font-family: Poppins-B;
    font-size: 11px;
    padding: 4px 9px;
    text-transform: uppercase;
  }

  .order-side.buy {
    background: #00a86b;
  }

  .order-side.sell {
    background: #d92d20;
    color: white;
  }

  > .content {
    height: calc(100% - 38px);
    box-sizing: border-box;
    padding: 12px;
    overflow-x: auto;
    overflow-y: auto;
  }

  .ticket-workspace {
    display: grid;
    grid-template-columns: 500px minmax(360px, 1fr);
    align-items: stretch;
    gap: 12px;
    height: 100%;
    min-width: 760px;
  }

  .order-fields,
  .settlement-panel {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    background-color: var(--mt-card);
    overflow: hidden;
  }

  .order-fields {
    display: grid;
    grid-template-columns: repeat(3, 148px);
    grid-auto-rows: minmax(66px, auto);
    gap: 7px;
    align-self: start;
    height: auto;
    justify-content: start;
    padding: 8px;
    border: 0;
    background: var(--mt-surface);
  }

  .ticket-label,
  .ticket-value {
    min-width: 0;
  }

  .ticket-label {
    display: block;
    padding: 0 0 5px;
    color: var(--mt-muted);
    font-size: 10px;
    line-height: 1;
    text-transform: uppercase;
    background: transparent;
  }

  .ticket-value {
    display: flex;
    min-height: 34px;
    align-items: center;
    padding: 0;
    color: var(--mt-text);
    font-family: Poppins-B;
    font-size: 15px;
    border: 0;
  }

  .field-card {
    min-width: 0;
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    background-color: var(--mt-card);
    padding: 8px 9px;
  }

  .field-card.action {
    border-color: rgba(255, 79, 31, 0.32);
    box-shadow: inset 3px 0 0 ${ORANGE};
  }

  .field-card.accent {
    border-color: rgba(255, 176, 0, 0.32);
    background: var(--mt-card);
  }

  .ticket-value.accent,
  .ticket-value.danger,
  .ticket-value.muted {
    background: transparent;
    box-shadow: none;
  }

  .ticket-value.placeholder {
    color: var(--mt-muted);
  }

  .ticket-value .ant-select {
    width: 100%;
  }

  .ticket-value
    .ant-select-single.ant-select-sm:not(.ant-select-customize-input)
    .ant-select-selector,
  .ticket-value .ant-input {
    height: 32px;
    border: 1px solid var(--mt-border);
    border-radius: 6px;
    background-color: var(--mt-card);
    color: var(--mt-text);
  }

  .ticket-value
    .ant-select-single.ant-select-sm:not(.ant-select-customize-input)
    .ant-select-selector {
    padding: 0 8px;
  }

  .settlement-panel {
    display: flex;
    flex-direction: column;
    padding: 10px 12px;
  }

  .settlement-title {
    margin-bottom: 8px;
    color: var(--mt-warning);
    font-family: Poppins-B;
    font-size: 12px;
    text-transform: uppercase;
  }

  .settlement-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex: 1;
    min-height: 25px;
    padding: 5px 0;
    border-top: 1px solid var(--mt-border);
    color: var(--mt-muted);
    font-size: 12px;
  }

  .settlement-row:first-of-type {
    border-top: 0;
  }

  .settlement-row strong {
    color: var(--mt-text);
    font-family: Poppins-B;
    white-space: nowrap;
  }

  .settlement-row.total {
    margin-top: 6px;
    padding-top: 10px;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .settlement-row.total strong {
    color: var(--mt-warning);
    font-size: 15px;
  }

  @media (max-width: 760px) {
    > .content {
      max-height: none;
    }

    .ticket-workspace {
      min-width: 0;
      grid-template-columns: 1fr;
    }

    .order-fields {
      grid-template-columns: 1fr;
      grid-auto-rows: auto;
    }
  }
`;

export const getYieldToMaturity = (
  settlementDate: Date,
  maturityDate: Date,
  issueDate: Date,
  rate: number,
  faceValue: number,
  price: number,
) => {
  // Convertir les dates en objets Date
  settlementDate = new Date(settlementDate);
  maturityDate = new Date(maturityDate);
  issueDate = new Date(issueDate);

  // Calculer le nombre de jours entre la date d'émission et la date d'échéance
  const N =
    (maturityDate.getTime() - issueDate.getTime()) / (1000 * 60 * 24 * 365);

  // Calculer le nombre de jours entre la date d'émission et la date de règlement
  const A =
    (settlementDate.getTime() - issueDate.getTime()) / (1000 * 60 * 24 * 365);
  // Calculer le rendement à l'échéance
  const yieldToMaturity =
    ((faceValue - price) / price) * (365 / (N - A)) +
    (rate * faceValue) / price;

  return yieldToMaturity;
};

const getNextCouponDate = (
  dateTransaction: Date,
  maturityDate: Date,
  frequency: number,
) => {
  let nextDate = new Date(maturityDate);

  while (nextDate.getTime() > dateTransaction.getTime()) {
    nextDate.setMonth(nextDate.getMonth() - 12 / frequency);
  }
  nextDate.setMonth(nextDate.getMonth() + 12 / frequency);
  return nextDate;
};

export const OrderEntry = ({
  selectedTitre,
  selectedOpe,
  orderPrefill,
  detenteurVendeur,
  titreBidAsk,
  updateProfondeur,
}: {
  selectedTitre?: TitreEntity;
  selectedOpe: string;
  orderPrefill?: OrderPrefill;
  detenteurVendeur?: string;
  titreBidAsk: TitreBidAskType;
  updateProfondeur: () => void;
}) => {
  const datejour = new Date();
  const valeurNominale = 10000;
  const [clicked, setClicked] = useState('0');
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [operation, setOperation] = useState({
    qte: 0,
    prix: 0,
  });
  const [lmtOptions, setLmtOptions] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDetenteur, setSelectedDetenteur] = useState('');
  const [param, setParam] = useState<any>({
    com_intermediation: 0,
    com_conservation: 0,
    droit_garde: 0,
    com_courtage: 0,
    mnt_global: 0,
    decote: 0,
    valaPay: 0,
    valaPercevoir: 0,
    com1: 0,
    com2: 0,
    com3: 0,
    com4: 0,
    montant: 0,
    prix: 0,
  });

  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const [favorisClick, setFavorisClick] = useState(false);
  interface PriceItem {
    value: number;
    label: string;
  }

  useEffect(() => {
    if (selectedTitre) {
      let prices: PriceItem[] = [];
      let percent = 0.85;
      let val = 0;
      while (percent <= 1.16) {
        val = Math.floor(selectedTitre.valeurNominale * percent);
        prices.push({
          value: val,
          label: `${Math.floor(percent * 100)}% - ${formatNum(val)} XAF`,
        });
        percent += 0.01;
      }

      setLmtOptions(prices);
    }
  }, [selectedTitre]);

  useEffect(() => {
    setClicked(selectedOpe);
  }, [selectedOpe]);

  useEffect(() => {
    if (!orderPrefill) return;

    setOperation({
      prix: Number(orderPrefill.prix) || 0,
      qte: Number(orderPrefill.qte) || 0,
    });
  }, [orderPrefill]);

  const annulerOrdre = () => {
    setOperation({ qte: 0, prix: 0 });
    setShowModal(false);
  };

  const sendOffer = () => {
    setIsLoading(true);
    var qte = operation.qte;
    var prix = operation.prix;
    var rendement = 0;
    if (param) {
      qte = param.qte;
      prix = 10000;
      rendement = getYieldToMaturity(
        datejour,
        dateMature,
        dateEmission,
        selectedTitre?.tauxMarginal ?? 0,
        valeurNominale,
        prix,
      );
    }
    console.log(param, qte, prix);
    let operationToCreate = {
      code: generate(),
      typeOperation: clicked === '1' ? 'ACHAT' : 'VENTE',
      dateOperation: `${new Date().getFullYear()}-${
        new Date().getMonth() + 1
      }-${new Date().getDate()}`,
      qteOriginal: qte,
      qteRestant: qte,
      prixNominale: prix,
      montantOriginal: qte * valeurNominale,
      montantRestant: qte * valeurNominale,
      decote: decote,
      tauxInteret: selectedTitre?.tauxMarginal,
      tauxRendement: rendement.toFixed(2),
      frequence: selectedTitre?.frequencePaiement,
      couponCouruPayer: Number(valaPay),
      couponPercevoir: Number(valaPercevoir),
      commIntermediation:
        clicked === '1' ? Math.round((prix * qte * 0.27) / 100) : 0,
      commConservation:
        clicked === '1' ? Math.round((prix * qte * 0.2) / 100) : 0,
      commDroitGarde:
        clicked === '1' ? Math.round((prix * qte * 0.3) / 100) : 0,
      commBrokerage: clicked === '1' ? Math.round((prix * qte * 0.2) / 100) : 0,
      statut: 'En attente',
      titre: selectedTitre?.url,
      utilisateur: connectedUser.url,
      detenteur: selectedDetenteur || detenteurVendeur,
    };
    console.log(operationToCreate);

    createOperation(operationToCreate).then(({ statusCode, data }) => {
      console.log(data);
      if (statusCode.toString()[0] === '2') {
        notification.success({
          message: 'Offre transmis',
          description: 'Votre ordre a été transmis avec succès ',
        });
        // afficher le statuts des matchs
        notification.info({
          message: "Statut de l'ordre",
          description: data.match.message,
        });
        updateProfondeur();
      } else {
        notification.error({
          message: 'Erreur',
          description: data.message,
        });
      }
      setIsLoading(false);
      setShowModal(false);
      setShowModal1(false);
      // history.go(0);
    });
  };

  const addFavoris = () => {
    let objToPost = {
      titre: selectedTitre?.url,
      utilisateur: connectedUser.url,
    };
    createFavoris(objToPost).then((resp) => {
      console.log(resp);
      setFavorisClick(true);
    });
  };

  useEffect(() => {
    // reset click on favoris back to default
    setFavorisClick(false);
  }, [selectedTitre]);

  var decote = 100 - operation.prix / 100;
  var prixT =
    clicked === '1' ? operation.prix / 100 + 0.97 : operation.prix / 100;
  var prixCom = (operation.prix * operation.qte * 0.97) / 100;
  var valaPay = '0';
  var valaPercevoir = '0';
  var dateCoupn = new Date();
  var rendement = 0;
  if (selectedTitre?.dateMaturite) {
    var dateMature = new Date(selectedTitre?.dateMaturite);
    var dateEmission = new Date(selectedTitre?.dateEmission);
    var duree_annee =
      (dateMature.getTime() - datejour.getTime()) / (1000 * 60 * 24 * 365);
    //recupérons les chiffres après la virgule
    var valString = duree_annee.toString();
    var nbre = valString.split('.');
    var delta = parseFloat('0.' + nbre[1]);
    const prixTaux =
      (operation.qte * valeurNominale * selectedTitre?.tauxMarginal) / 100;
    const valaRestant = prixTaux * delta;
    valaPercevoir = valaRestant.toFixed(2);
    var valaPayer = prixTaux - parseFloat(valaPercevoir);
    valaPay = valaPayer.toFixed(2);
    dateCoupn = getNextCouponDate(datejour, dateMature, 1);
    rendement = getYieldToMaturity(
      datejour,
      dateMature,
      dateEmission,
      selectedTitre?.tauxMarginal,
      valeurNominale,
      operation.prix,
    );
  }
  const totalReglement =
    clicked === '1'
      ? Math.round(
          operation.prix * operation.qte +
            operation.prix * operation.qte * 0.0097 +
            parseFloat(valaPay),
        )
      : Math.round(
          operation.prix * operation.qte -
            operation.prix * operation.qte * 0.0097 +
            parseFloat(valaPay),
        );

  return (
    <Container>
      <div className='top'>
        <Space>
          <div className='ticket-title'>
            <span className='ticket-kicker'>Saisie d'ordres</span>
            {selectedTitre && clicked !== '0' && (
              <span
                className={`order-side ${clicked === '1' ? 'buy' : 'sell'}`}
              >
                {clicked === '1' ? 'Achat' : 'Vente'}
              </span>
            )}
          </div>

          {selectedTitre && (
            <Space>
              <Tooltip title='Ajouter aux favoris'>
                <FaStar
                  size={16}
                  style={{ cursor: 'pointer', textAlign: 'right' }}
                  color={favorisClick ? YELLOW : undefined}
                  onClick={addFavoris}
                />
              </Tooltip>
            </Space>
          )}
        </Space>

        <Space wrap>
          <Button
            className='butt'
            disabled={!selectedTitre}
            style={{ borderRadius: 20, height: 28 }}
            onClick={() => setShowModal1(true)}
          >
            <div style={{ marginTop: -2, fontSize: 13 }}>
              Acheter une Fraction
            </div>
          </Button>

          <Button
            className='butt'
            disabled={!selectedTitre}
            style={{ borderRadius: 20, height: 28 }}
            onClick={() => setShowModal(true)}
          >
            <div style={{ marginTop: -2, fontSize: 13 }}>Soumettre</div>
          </Button>
        </Space>
      </div>

      <div className='content'>
        <div className='ticket-workspace'>
          <div className='order-fields'>
            <div className='field-card accent'>
              <div className='ticket-label'>Date valeur</div>
              <div className='ticket-value accent'>
                {moment(new Date()).format('DD/MM/YYYY')}
              </div>
            </div>

            <div className='field-card action'>
              <div className='ticket-label'>Prix</div>
              <div className='ticket-value danger'>
                <Select
                  size='small'
                  value={operation.prix}
                  style={{ width: '100%', minWidth: 130 }}
                  options={lmtOptions}
                  onChange={(val) =>
                    setOperation({ ...operation, prix: Number(val) })
                  }
                />
              </div>
            </div>

            <div className='field-card action'>
              <div className='ticket-label'>Quantité</div>
              <div className='ticket-value danger'>
                <Input
                  className='qteInput'
                  placeholder='qte'
                  value={operation.qte}
                  type='number'
                  min={0}
                  onChange={(e) =>
                    setOperation({
                      ...operation,
                      qte: Number(e.target.value),
                    })
                  }
                />
              </div>
            </div>

            <div className='field-card'>
              <div className='ticket-label'>Décote</div>
              <div className='ticket-value muted'>
                {operation.prix
                  ? `${formatNum(parseFloat(decote.toFixed(2)))}%`
                  : '--'}
              </div>
            </div>

            <div className='field-card'>
              <div className='ticket-label'>Prix total</div>
              <div className='ticket-value muted'>
                {operation.prix
                  ? `${formatNum(parseFloat(prixT.toFixed(2)))}%`
                  : '--'}
              </div>
            </div>

            <div className='field-card accent'>
              <div className='ticket-label'>Rendement</div>
              <div
                className={`ticket-value accent ${
                  Number.isFinite(rendement) ? '' : 'placeholder'
                }`}
              >
                {Number.isFinite(rendement)
                  ? formatNum(parseFloat(rendement.toFixed(2)))
                  : '--'}
              </div>
            </div>
          </div>

          <div className='settlement-panel'>
            <div className='settlement-title'>Aperçu règlement</div>
            <div className='settlement-row'>
              <span>Valeur nominale</span>
              <strong>{formatNum(valeurNominale)} XAF</strong>
            </div>
            <div className='settlement-row'>
              <span>Montant global</span>
              <strong>{formatNum(operation.qte * valeurNominale)} XAF</strong>
            </div>
            <div className='settlement-row'>
              <span>Total commissions</span>
              <strong>
                {clicked === '1'
                  ? formatNum(parseFloat(prixCom.toFixed(2)))
                  : 0}{' '}
                XAF
              </strong>
            </div>
            <div className='settlement-row'>
              <span>Coupon couru à payer</span>
              <strong>{formatNum(parseInt(valaPay))} XAF</strong>
            </div>
            <div className='settlement-row'>
              <span>Prochain coupon</span>
              <strong>{moment(dateCoupn).format('DD/MM/YYYY')}</strong>
            </div>
            <div className='settlement-row'>
              <span>Coupon à percevoir</span>
              <strong>{formatNum(parseInt(valaPercevoir))} XAF</strong>
            </div>
            <div className='settlement-row total'>
              <span>{clicked === '1' ? 'Total à payer' : 'Total à percevoir'}</span>
              <strong>{formatNum(totalReglement)} XAF</strong>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className='dark-modal'
        open={showModal}
        title="Confirmation de l'ordre"
        onCancel={() => setShowModal(false)}
        width={800}
        footer={[
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              danger
              onClick={() => setShowModal(false)}
              style={{ border: '2px solid red', borderRadius: 20 }}
            >
              Fermer
            </Button>
            <Button
              danger
              onClick={annulerOrdre}
              style={{ border: '2px solid red', borderRadius: 20 }}
            >
              Annuler l'ordre
            </Button>
            <Button
              className='butt'
              loading={isLoading}
              style={{ borderRadius: 20 }}
              onClick={sendOffer}
              disabled={clicked === '2' ? false : !selectedDetenteur}
            >
              Transmettre l'ordre
            </Button>
          </div>,
        ]}
      >
        <ConfirmationOrder
          titre={selectedTitre as TitreEntity}
          typeOpe={clicked === '1' ? 'achat' : 'vente'}
          detailOpe={operation}
          getSelectedDetenteur={setSelectedDetenteur}
        />
      </Modal>
      <Modal
        className='dark-modal'
        open={showModal1}
        title='Acheter une fraction'
        onCancel={() => setShowModal1(false)}
        width={800}
        footer={[
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              danger
              onClick={() => setShowModal1(false)}
              style={{ border: '2px solid red', borderRadius: 20 }}
            >
              Fermer
            </Button>
            <Button
              className='butt'
              loading={isLoading}
              style={{ borderRadius: 20 }}
              onClick={sendOffer}
              disabled={clicked === '2' ? false : !selectedDetenteur}
            >
              Transmettre l'ordre
            </Button>
          </div>,
        ]}
      >
        <FractionOrder
          titre={selectedTitre as TitreEntity}
          typeOpe={clicked === '1' ? 'achat' : 'vente'}
          detailOpe={operation}
          getSelectedDetenteur={setSelectedDetenteur}
          getParam={setParam}
        />
      </Modal>
    </Container>
  );
};
